import { Col, message, Row } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { FaqFormCard, FaqInputDto } from "./components/FaqFormCard";
import { createFaq } from "../../../lib/api/resources/faq";

export const FaqCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createFaqMutation = useMutation({
    mutationFn: (data: FaqInputDto) => createFaq(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["faqs"],
      });
      message.success("Vraag & antwoord succesvol aangemaakt");
      navigate("/faqs");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het aanmaken van het vraag & antwoord",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <FaqFormCard mutation={createFaqMutation} />
      </Col>
    </Row>
  );
};
